import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// === ES (Spanish - Base) ===
import esCommon from './locales/es/common.json';
import esValidation from './locales/es/validation.json';
import esDashboard from './locales/es/dashboard.json';
import esPlatform from './locales/es/platform.json';
import esPayments from './locales/es/payments.json';
import esNotifications from './locales/es/notifications.json';
import esChannels from './locales/es/channels.json';
import esScores from './locales/es/scores.json';
import esNegotiation from './locales/es/negotiation.json';
import esAuth from './locales/es/auth.json';
import esFormatters from './locales/es/formatters.json';
import esHelp from './locales/es/help.json';

// === EN (English) ===
import enCommon from './locales/en/common.json';
import enValidation from './locales/en/validation.json';
import enDashboard from './locales/en/dashboard.json';
import enPlatform from './locales/en/platform.json';
import enPayments from './locales/en/payments.json';
import enNotifications from './locales/en/notifications.json';
import enChannels from './locales/en/channels.json';
import enScores from './locales/en/scores.json';
import enNegotiation from './locales/en/negotiation.json';
import enAuth from './locales/en/auth.json';
import enFormatters from './locales/en/formatters.json';
import enHelp from './locales/en/help.json';

// === PT (Portuguese) ===
import ptCommon from './locales/pt/common.json';
import ptValidation from './locales/pt/validation.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptPlatform from './locales/pt/platform.json';
import ptPayments from './locales/pt/payments.json';
import ptNotifications from './locales/pt/notifications.json';
import ptChannels from './locales/pt/channels.json';
import ptScores from './locales/pt/scores.json';
import ptNegotiation from './locales/pt/negotiation.json';
import ptAuth from './locales/pt/auth.json';
import ptFormatters from './locales/pt/formatters.json';
import ptHelp from './locales/pt/help.json';

const resources = {
  es: {
    common: esCommon,
    validation: esValidation,
    dashboard: esDashboard,
    platform: esPlatform,
    payments: esPayments,
    notifications: esNotifications,
    channels: esChannels,
    scores: esScores,
    negotiation: esNegotiation,
    auth: esAuth,
    formatters: esFormatters,
    help: esHelp,
  },
  en: {
    common: enCommon,
    validation: enValidation,
    dashboard: enDashboard,
    platform: enPlatform,
    payments: enPayments,
    notifications: enNotifications,
    channels: enChannels,
    scores: enScores,
    negotiation: enNegotiation,
    auth: enAuth,
    formatters: enFormatters,
    help: enHelp,
  },
  pt: {
    common: ptCommon,
    validation: ptValidation,
    dashboard: ptDashboard,
    platform: ptPlatform,
    payments: ptPayments,
    notifications: ptNotifications,
    channels: ptChannels,
    scores: ptScores,
    negotiation: ptNegotiation,
    auth: ptAuth,
    formatters: ptFormatters,
    help: ptHelp,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: [
      'common', 'validation', 'dashboard', 'platform', 'payments',
      'notifications', 'channels', 'scores', 'negotiation', 'auth', 'formatters', 'help'
    ],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false,
    },
  });

/**
 * Load translation overrides from the backend (translations table)
 * and merge them into i18next resources via addResourceBundle.
 * Uses fetch() directly to avoid axios import circular dependency.
 */
export async function loadTranslationOverrides(language) {
  try {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    const response = await fetch(`${baseUrl}/translations/${language}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) return;

    const data = await response.json();
    if (!data.success || !data.data) return;

    // data.data is { namespace: { key: value } }
    for (const [ns, translations] of Object.entries(data.data)) {
      i18n.addResourceBundle(language, ns, translations, true, true);
    }
  } catch (error) {
    console.warn('Failed to load translation overrides:', error.message);
  }
}

export default i18n;
